import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
`

export const InputContainer = styled.div<{ width?: string }>`
  display: flex;
  height: 2rem;
  gap: 1rem;
  top: -3rem;
  right: 2.5rem;
  position: absolute;
  align-self: flex-end;
  flex-direction: column;
  width: ${(props) => (props.width ? props.width : '100%')};
`
